import moment from 'moment';

const getEndMoment = (goal: GeneralGoal) => {
  const { fixedEndDate } = goal;
  return moment.utc(fixedEndDate);
};

export default getEndMoment;
